import React from 'react';
import { IoIosMenu, IoMdClose } from 'react-icons/io';

import { SignOutButton } from 'modules/auth';
import IMAGES from 'modules/assets/web';

import NavItems from '../nav/NavItems';

class TopHeader extends React.Component {
  state = {
    showDropdown: false,
  };

  toggleDropdown = () => {
    this.setState({
      showDropdown: !this.state.showDropdown,
    });
  };

  render() {
    const { showDropdown } = this.state;

    const customClassName = showDropdown ? 'show' : 'hide';

    return (
      <nav className="navbar navbar-dark sticky-top d-md-none p-0">
        <div className="navbar-header bg-dark">
          <div className="app-logo-wrapper bg-dark p-2">
            <img
              className="header-logo m-auto"
              src={IMAGES.LOGO_RED}
              alt="NF Logo"
            />
          </div>
          <button
            className="navbar-toggler dropdown-toggle-button"
            type="button"
            data-target="#dropdownMenus"
            onClick={this.toggleDropdown}
          >
            <IoIosMenu size={30} color="white" />
          </button>
        </div>
        <div
          id="dropdownMenus"
          className={`collapse navbar-collapse fixed-top bg-light ${customClassName}`}
        >
          <div className="dropdown-content">
            <button
              className="navbar-toggler dropdown-toggle-button"
              type="button"
              data-target="#dropdownMenus"
              onClick={this.toggleDropdown}
            >
              <IoMdClose size={30} color="white" />
            </button>
            <div className="nav-item signout position-absolute">
              <SignOutButton />
            </div>
            <div className="bg-dark pt-2">
              <img
                className="header-logo d-block mx-auto"
                src={IMAGES.LOGO_RED}
                alt="NF Logo"
              />
              <img
                alt="city-scape"
                className="img-fluid"
                src={IMAGES.SIDEBAR_CITYSCAPE}
              />
            </div>
            <ul className="nav flex-column flex-nowrap position-relative">
              <NavItems onClick={this.toggleDropdown} />
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default TopHeader;
